<h3 mat-dialog-title i18n>Archive Project</h3>
  <mat-dialog-content>
      <mat-form-field>
          <input type="number" placeholder="Total Invoiced" aria-label="Number" matInput [formControl]="finalInvoiced" i18n-placeholder>
      </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
          <button type="submit" mat-button (click)="closeDialog()" [disabled]="!isValid" i18n>Submit</button>
  </mat-dialog-actions>
  


// WEBPACK FOOTER //
// ./src/app/budget/budget-detail.component.ts.ArchiveProjectDialogComponent.html